import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';

@Component({
  selector: 'app-finish-assessment',
  templateUrl: './finish-assessment.component.html',
  styleUrls: ['./finish-assessment.component.scss']
})
export class FinishAssessmentComponent implements OnInit {

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) { }

  ngOnInit() {
  }

}
